import { useEffect, useState } from 'react'
import { AbiItem } from 'web3-utils'
import { ReactSession } from 'react-client-session';
import useWeb3 from '../hooks/useWeb3'
import StandardToken from '../config/abi/StandardToken.json'
import StandardTokenMintable from '../config/abi/StandardTokenMintable.json' 
import LiquidityGenerator from '../config/abi/LiquidityGenerator.json' 
import LiquidityGeneratorBurnable from '../config/abi/LiquidityGeneratorBurnable.json' 
import TokenCreatorFactory from '../config/abi/TokenCreatorFactory.json' 
import Contracts from '../config/Contracts.json' 



const useContract = (abi: AbiItem, address: string, contractOptions?: ContractOptions) => {
    const web3 = useWeb3()
    const [contract, setContract] = useState(new web3.eth.Contract(abi, address, contractOptions))
  
    useEffect(() => {
      setContract(new web3.eth.Contract(abi, address, contractOptions))
    }, [abi, address, contractOptions, web3])
  
    return contract
  }

  const selectedFactory = ()=>{
    const Factory = Contracts.find(network => network.chain === ReactSession.get("network").networkname);
    return Factory.factory;
  }


  export const useTokenCreatorFactoryContract = () => {
    const abi = TokenCreatorFactory;
    return useContract(abi, selectedFactory())
  }

  export const useStandardTokenContract = (contract) => {
    const abi = StandardToken;
    return useContract(abi, contract)
  }

  export const useStandardTokenMintableContract = (contract) => {
    const abi = StandardTokenMintable;
    return useContract(abi, contract)
  }

  export const useLiquidityGeneratorContract = (contract) => {
    const abi = LiquidityGenerator;
    return useContract(abi, contract)
  }

  export const useLiquidityGeneratorBurnableContract = (contract) => {
    const abi = LiquidityGeneratorBurnable;
    return useContract(abi, contract)
  }